import { useState } from 'react';
import { PageHead } from 'ui/kit/PageHead';
import { useNavigate } from 'react-router';

import { SupportContactForm } from 'components/SupportContactForm/SupportContactForm';
import { useAuthSession } from 'hooks/useAuthSession';
import { marketingLinks } from 'utils/siteLinks';

import classes from './t3Screen.module.scss';

const maskEmail = (email: string) => {
  const [name, domain] = email.split('@');
  if (!name || !domain) return email;
  return `${name.slice(0, 1)}***@${domain}`;
};

export const TeacherHelp = () => {
  const navigate = useNavigate();
  const { data: session } = useAuthSession();
  const [sent, setSent] = useState<{ subject: string } | null>(null);
  const email = session?.email ? maskEmail(session.email) : 'почту аккаунта';

  if (sent) {
    return (
      <main className={classes.page}>
        <PageHead crumb={<>Личный кабинет / Тех.поддержка</>} title={<>Обращение отправлено</>} />
        <section className={classes.card}>
          <h2 className={classes.cardTitle}>Обращение отправлено</h2>
          <p className={classes.label}>Тема</p>
          <p className={classes.body}>{sent.subject}</p>
          <p className={classes.label}>Куда придет ответ</p>
          <p className={classes.body}>На почту аккаунта: {email}</p>
          <p className={classes.callout}>
            Срок ответа не указан. Проверьте почту аккаунта и папку Спам. Пароль и коды в
            переписку не присылайте.
          </p>
          <button type='button' className={classes.primary} onClick={() => navigate('/teacher/settings')}>
            Вернуться в настройки
          </button>
        </section>
      </main>
    );
  }

  return (
    <main className={classes.page}>
      <PageHead crumb={<>Личный кабинет / Тех.поддержка</>} title={<>Обращение в поддержку</>} />
      <section className={classes.card}>
        <h2 className={classes.cardTitle}>Опишите вопрос</h2>
        <p className={classes.body}>
          Как откликнуться, заполнить анкету и открыть чат - в{' '}
          <a href={marketingLinks.guides}>инструкциях</a>.
        </p>
        <p className={classes.callout}>
          Не добавляйте реквизиты карты, коды или паспортные данные в сообщение.
        </p>
        <SupportContactForm
          roleLabel='репетитор'
          replyEmail={email}
          onSent={(payload) => setSent({ subject: payload.subject })}
          onCancel={() => navigate('/teacher/settings')}
        />
      </section>
    </main>
  );
};
